import { useMemo } from 'react';
import { useMatches } from 'react-router-dom';

import type { AnyRecord } from '@sso/shared/types';

export default function useRouteHandle(): AnyRecord {
    const matches = useMatches();

    return useMemo(
        () =>
            matches.reduce(
                (handle, match) => (match.handle ? { ...handle, ...match.handle } : handle),
                {},
            ),
        [matches],
    );
}
